import { Link } from "react-router-dom";

const TEXT_COLOR = "#545454";
const BORDER_SOFT = "rgba(84,84,84,0.14)";

export default function ShopFooter() {
  return (
    <footer
      style={{
        background: "#FFFFFF",
        borderTop: `1px solid ${BORDER_SOFT}`,
        color: TEXT_COLOR,
        fontFamily: "'Inter Tight', sans-serif",
      }}
    >
      {/* Editorial top strip */}
      <div
        style={{
          maxWidth: 1400,
          margin: "0 auto",
          padding: "56px 40px 40px",
        }}
      >
        <div
          className="grid"
          style={{
            gridTemplateColumns: "1.4fr 1fr 1fr 1fr",
            gap: 40,
          }}
        >
          {/* Brand column */}
          <div>
            <div
              style={{
                fontFamily: "'Instrument Serif', serif",
                fontStyle: "italic",
                fontSize: 32,
                letterSpacing: "-0.8px",
                marginBottom: 14,
                lineHeight: 1,
              }}
            >
              maison{" "}
              <span style={{ fontStyle: "normal", fontFamily: "'Inter Tight', sans-serif", fontSize: 26, fontWeight: 500, letterSpacing: "-1px" }}>
                des jouets
              </span>
            </div>
            <p
              style={{
                fontSize: 13,
                lineHeight: 1.75,
                color: "rgba(84,84,84,0.7)",
                maxWidth: 320,
              }}
            >
              A small atelier in Milano. Six sets of hands, one basket of yarn, and
              a very slow way of making things.
            </p>
          </div>

          <FooterColumn
            number="(a)"
            title="Wander"
            links={[
              { label: "Catalog", to: "/catalog" },
              { label: "The story", to: "/story" },
              { label: "Journal", href: "#" },
              { label: "Ateliers", href: "#" },
            ]}
          />
          <FooterColumn
            number="(b)"
            title="Atelier"
            links={[
              { label: "Care & repair", href: "#" },
              { label: "Shipping", href: "#" },
              { label: "Returns", href: "#" },
              { label: "Contact", href: "#" },
            ]}
          />
          <FooterColumn
            number="(c)"
            title="Follow"
            links={[
              { label: "Instagram", href: "#" },
              { label: "Pinterest", href: "#" },
              { label: "Journal", href: "#" },
              { label: "Newsletter", href: "#" },
            ]}
          />
        </div>
      </div>

      {/* Signature band */}
      <div style={{ borderTop: `1px solid ${BORDER_SOFT}` }}>
        <div
          className="flex flex-col md:flex-row items-start md:items-center justify-between"
          style={{
            maxWidth: 1400,
            margin: "0 auto",
            padding: "22px 40px",
            gap: 14,
            fontSize: 11,
            letterSpacing: "2px",
          }}
        >
          <span style={{ color: "rgba(84,84,84,0.55)" }}>
            © 2026 MAISON DES JOUETS · MILANO / PARIS
          </span>
          <span
            style={{
              fontFamily: "'Instrument Serif', serif",
              fontStyle: "italic",
              fontSize: 20,
              color: "rgba(84,84,84,0.5)",
              letterSpacing: "-0.4px",
            }}
          >
            — made slowly, with love
          </span>
          <span style={{ color: "rgba(84,84,84,0.55)" }}>
            HANDCRAFTED · SINCE 2019
          </span>
        </div>
      </div>
    </footer>
  );
}

interface FooterLink {
  label: string;
  to?: string;
  href?: string;
}

function FooterColumn({
  number,
  title,
  links,
}: {
  number: string;
  title: string;
  links: FooterLink[];
}) {
  return (
    <div>
      <div className="flex items-baseline" style={{ gap: 10, marginBottom: 18 }}>
        <span
          style={{
            fontFamily: "'Instrument Serif', serif",
            fontStyle: "italic",
            fontSize: 16,
            color: "rgba(84,84,84,0.5)",
          }}
        >
          {number}
        </span>
        <span
          style={{
            fontSize: 12,
            fontWeight: 500,
            letterSpacing: "2px",
            color: TEXT_COLOR,
            textTransform: "uppercase",
          }}
        >
          {title}
        </span>
      </div>
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {links.map((l) => (
          <li key={l.label} style={{ marginBottom: 10 }}>
            {l.to ? (
              <Link
                to={l.to}
                className="cursor-pointer hover:opacity-60 transition-opacity"
                style={{
                  fontSize: 13,
                  color: "rgba(84,84,84,0.75)",
                  textDecoration: "none",
                }}
              >
                {l.label}
              </Link>
            ) : (
              <a
                href={l.href}
                className="cursor-pointer hover:opacity-60 transition-opacity"
                style={{
                  fontSize: 13,
                  color: "rgba(84,84,84,0.75)",
                  textDecoration: "none",
                }}
              >
                {l.label}
              </a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}